import React from "react";

import { Radio } from "antd";
import { useIntl } from "react-intl";

import { Activity } from "@mapmycustomers/shared/types/entity";

import RadioGroup from "@app/component/input/RadioGroup";
import useCalendarView from "@app/component/view/CalendarView/utils/useCalendarView";
import CalendarViewMode, { getCalendarViewModeDisplayName } from "@app/enum/CalendarViewMode";

interface Props {}

const ViewModeButton: React.FC<Props> = () => {
  const intl = useIntl();
  const { changeViewMode, viewState } = useCalendarView<Activity>();

  const handleViewModeChange = (newViewMode: CalendarViewMode) => changeViewMode(newViewMode);
  return (
    <RadioGroup<CalendarViewMode>
      onChange={handleViewModeChange}
      size="small"
      value={viewState.viewMode}
    >
      {[CalendarViewMode.DAY, CalendarViewMode.WEEK].map((mode) => (
        <Radio.Button key={mode} value={mode}>
          {getCalendarViewModeDisplayName(intl, mode)}
        </Radio.Button>
      ))}
    </RadioGroup>
  );
};

export default ViewModeButton;
